import { assign, mapValues } from 'lodash';
import { fromJS } from 'immutable';
import Constants from '../../constants';

const { PublicFiles } = Constants;
const initialState = fromJS({
  loading: false,
  error: null,
  publicFilesUrls: {},
});

const publicFilesReducer = (state = initialState, action) => {
  const { error, file, publicFilesUrls, progressEvent } = action;

  switch (action.type) {
    case PublicFiles.GET_FILES:
      return state.set('loading', true);
    case PublicFiles.GET_FILES_ERROR:
      return state.set('loading', false).set('error', error);
    case PublicFiles.GET_FILES_SUCCESS:
      return state
        .set('loading', false)
        .set('publicFilesUrls', fromJS(publicFilesUrls));
    case PublicFiles.UPLOAD_FILE:
      return state.setIn(
        ['publicFilesUrls', file.name],
        assign(state.get('publicFilesUrls')[file.name], { loading: true }),
      );
    case PublicFiles.UPLOAD_FILE_ERROR:
      return state.set(
        'publicFilesUrls',
        fromJS(
          mapValues(publicFilesUrls, (v) =>
            assign(v, { loading: false, error }),
          ),
        ),
      );
    case PublicFiles.UPLOAD_FILE_SUCCESS:
      return state.set(
        'publicFilesUrls',
        fromJS(
          mapValues(publicFilesUrls, (v) =>
            assign(v, { loading: false, error: null }),
          ),
        ),
      );
    case PublicFiles.UPLOAD_FILE_PROGRESS:
      return state.setIn(
        ['publicFilesUrls', file.name],
        assign(state.get('publicFilesUrls')[file.name], {
          progressEvent: {
            total: progressEvent.total,
            loaded: progressEvent.loaded,
            timeStamp: progressEvent.timeStamp,
          },
        }),
      );
    default:
      return state;
  }
};

export default publicFilesReducer;
